/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, bool, func, number, object, oneOfType, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';

// helper
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';

const styles = (theme) => ({
    frequencyWrapper: {
        width: '100%',
    },
    frequencySelectRoot: {
        border: '1px solid #C6C6C6',
        boxSizing: 'border-box',
        minHeight: '58px',
        position: 'relative',
        fontSize: '1em',
        padding: '12px 16px',
        width: '100%',
        borderRadius: '5px',
        backgroundColor: '#FFF',
        '&:focus': {
            borderRadius: '5px',
        },
    },
    frequencySelect: {
        width: '100%',
        lineHeight: '1.4',
        fontSize: '1em',
        '& .MuiSelect-icon': {
            color: theme.palette?.black || '#000',
        },
    },
    locationTypeLabel: {
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
    },
    subscriptionContent: {
        flex: '1 1 0',
        minWidth: 0,
    },
    frequencySelectIcon: {
        color: '#000',
    },
});

const SubscriptionDropDown = ({
    classes,
    subscriptionsList,
    handleChange,
    selectValue,
    dropdownType,
    frequencyOrDuration,
    fieldLabel,
    isShowingDropdown,
    defaultValue,
}) => {
    if (!isShowingDropdown) {
        return (
            <div className={classes.subscriptionContent}>
                <div className={classes.frequencyWrapper}>
                    <p className={classes.locationTypeLabel}>{fieldLabel}</p>
                    <div className={classes.frequencySelectRoot}>{defaultValue}</div>
                </div>
            </div>
        );
    }

    const dropdownListArray = Object.keys(subscriptionConfig?.[dropdownType]).map((item) => {
        const obj = {
            id: Number(item), // convert string to integer
            value: subscriptionConfig?.[dropdownType][item],
        };
        return obj;
    });

    const subscriptionOptionList = dropdownListArray.filter((item) => subscriptionsList?.[frequencyOrDuration]?.includes?.(item.id));
    return (
        <div className={classes.subscriptionContent}>
            <div className={classes.frequencyWrapper}>
                <p className={classes.locationTypeLabel}>{fieldLabel}</p>
                <Select
                    className={classes.frequencySelect}
                    name={frequencyOrDuration}
                    id={frequencyOrDuration}
                    data-testid="pdp-frequency-type"
                    native
                    title={frequencyOrDuration}
                    disableUnderline
                    value={selectValue}
                    inputProps={{
                        'aria-label': fieldLabel,
                        classes: {
                            select: classes.frequencySelect,
                            root: classes.frequencySelectRoot,
                            icon: classes.frequencySelectIcon,
                        },
                    }}
                    onChange={(e) => handleChange(e, frequencyOrDuration, subscriptionOptionList)}
                >
                    {subscriptionOptionList.map((item) => <option value={item?.id} key={item.id}>{item?.value}</option>)}
                </Select>
            </div>
        </div>
    );
};

SubscriptionDropDown.propTypes = {
    classes: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    handleChange: func.isRequired,
    frequencyOrDuration: string,
    selectValue: oneOfType([number, string]).isRequired,
    dropdownType: string,
    fieldLabel: string,
    isShowingDropdown: bool,
    defaultValue: string,
};

SubscriptionDropDown.defaultProps = {
    frequencyOrDuration: 'interval',
    fieldLabel: 'Frequency:',
    dropdownType: 'subscription_interval',
    isShowingDropdown: false,
    defaultValue: '',
};
export default (withStyles(styles)(SubscriptionDropDown));
